<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 13:54:40
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-18 14:34:43
 * @Description: 优惠券详情
-->
<template>
  <a-card :title="title">
    <a-spin :spinning="submitLoading">
      <!-- 基础信息 -->
      <basicInfoForm :platformList="platformList" :project="project" ref="refBasic"></basicInfoForm>
      <!-- 发放和领取 -->
      <receiveForm :platformList="platformList" :project="project" ref="refReceiveForm"></receiveForm>
      <!-- 使用限制 -->
      <useConstraintForm :platformList="platformList" :project="project" ref="refConstraint"></useConstraintForm>
      <!-- 其他设置 -->
      <otherSettingForm ref="refOtherSetting"></otherSettingForm>

      <a-row>
        <a-col :span="12" :offset="2">
          <a-space size="large">
            <a-button type="primary" @click="handlePublish" :disabled="submitLoading">立即发布</a-button>
            <a-button type="default" @click="handleSaveDraft" :disabled="submitLoading">保存为草稿</a-button>
            <a-button type="default" @click="back">返回</a-button>
          </a-space>
        </a-col>
      </a-row>
    </a-spin>
  </a-card>
</template>
<script>
import { reactive, onMounted, toRefs, computed, watch, getCurrentInstance, ref } from '@vue/composition-api'
import initList from './composables/initList'
// import { casesTemplateFields, casesDetail } from '@/api/caseManagement/index'
import { couponList, couponCreate, couponDetail, couponUpdate } from '@/api/coupon/index'
import VDatePicker from '@/components/FormElements/VDatePicker'
import basicInfoForm from './components/basicInfoForm.vue'
import receiveForm from './components/receiveForm.vue'
import useConstraintForm from './components/useConstraintForm.vue'
import otherSettingForm from './components/otherSettingForm.vue'

const title = {
  Add: '添加优惠券',
  Edit: '编辑优惠券'
}

export default {
  components: {
    VDatePicker,
    basicInfoForm,
    receiveForm,
    useConstraintForm,
    otherSettingForm
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const isEdit = computed(() => !!_this.$route.params.id)
    const couponID = computed(() => _this.$route.params.id)

    const state = reactive({
      form: { project: null },
      title: title.Add,
      submitLoading: false,
      model: {}
    })

    const tagVisible = ref(null)
    onMounted(async () => {
      const id = couponID.value
      if (id) {
        state.title = title.Edit
        getDetail(id)
      } else {
        state.form.project = _this.project
      }
    })

    async function getDetail(id) {
      state.submitLoading = true
      couponDetail({ id }).then(res => {
        if (res.code === '000000') {
          // res.data
          state.model = res.data
          methods.setAllValue(res.data)
        }
      }).finally(() => {
        state.submitLoading = false
      })
    }
    function commitAction(postParams, flag) {
      return new Promise(async (resolve, reject) => {
        _this.submitLoading = true
        const requestAction = couponID.value ? couponUpdate({ ...postParams, id: couponID.value }) : couponCreate(postParams)
        requestAction.then(res => {
          if (_this.$validate(res) && res.data && res.data.id) {
          _this.back()
          resolve()
          } else {
          reject(new Error())
          }
        }).catch(() => {
          reject(new Error())
        }).finally(() => {
          _this.submitLoading = false
        })
      })
    }
    /**
     * 检查优惠券是否存在
     * @param {*} coupon_name
     */
    async function validCouponExists(coupon_name) {
      return new Promise((resolve, reject) => {
        const params = { coupon_name, project: _this.project }
        if (couponID.value) {
          params.id_not = couponID.value
        }
        couponList(params).then(res => {
          const isExists = res.code === '000000' && res.data.pagination.total > 0
          if (isExists) {
            _this.$confirm({
              okText: '已确认，继续保存',
              cancelText: '取消',
              content: '当前优惠券名称已存在，请确认是否重复添加？',
              onOk() {
                resolve()
              },
              onCancel() {
                reject(new Error(false))
              }
            })
          } else {
            resolve()
          }
        }).catch((err) => {
          reject(err)
        })
      })
    }

    const methods = {
      /**
       * 发布
       */
      handlePublish() {
        this.getAllValue(true).then(form => {
          try {
              _this.submitLoading = true
              validCouponExists(form.coupon_name).then(() => {
                commitAction({ ...form, state: 2 }, 2).then(() => {
                  _this.$message.success('发布成功！')
                }).catch(() => {
                  _this.$message.error('发布失败！')
                })
              }).catch(() => {
                _this.submitLoading = false
              })
            } catch (error) {
              _this.submitLoading = false
            }
        }).catch(() => {
          this.$message.warning('请检查信息是否填写完成')
        })
      },
      /**
       * 保存为草稿
       */
      handleSaveDraft() {
        try {
          _this.validNotEmptyFields().then(res => {
            this.getAllValue().then((form) => {
              _this.submitLoading = true
              validCouponExists(form.coupon_name).then(() => {
                commitAction({ ...form, state: 1 }, 1).then(() => {
                  _this.$message.success('保存草稿成功!')
                }).catch(() => {
                  _this.$message.error('保存草稿失败!')
                })
              }).catch(() => {
                _this.submitLoading = false
              })
            })
          }).catch(() => {
            this.$message.warning('请检查信息是否填写完成')
          })
        } catch (error) {
          _this.submitLoading = false
        }
      },

      async validNotEmptyFields() {
        const valid = await Promise.all([
          _this.$refs.refBasic.validate(),
          _this.$refs.refReceiveForm.validNotEmptyFields(),
          _this.$refs.refConstraint.validNotEmptyFields(),
          _this.$refs.refOtherSetting.validNotEmptyFields(),
        ])
        return valid.every(success => success) ? Promise.resolve() : Promise.reject(new Error('valid fail'))
      },

      setAllValue(data) {
        _this.$refs.refBasic.setValue(data)
        _this.$refs.refReceiveForm.setValue(data)
        _this.$refs.refOtherSetting.setValue(data)
        _this.$refs.refConstraint.setValue(data)
      },

      async getAllValue(valid = false) {
        const forms = await Promise.all([
          _this.$refs.refBasic.getValue(valid),
          _this.$refs.refReceiveForm.getValue(valid),
          _this.$refs.refOtherSetting.getValue(valid),
          _this.$refs.refConstraint.getValue(valid)
        ])
        return forms.reduce((pre, curr) => {
          return { ...pre, ...curr }
        }, {})
      },

      async submit(data) {
        couponCreate(data)
      },

      validAllForm() {
        return Promise.all([
          _this.$refs.refBasic.validate(),
          _this.$refs.refReceiveForm.validate(),
          _this.$refs.refOtherSetting.validate(),
          _this.$refs.refConstraint.validate()
        ])
      },
      back() {
        this.$router.push('/coupon-manager')
      },
      getFormItemOptions(fieldValue) {
        let _options = []
        if (!fieldValue || !Array.isArray(fieldValue)) return _options
        _options = fieldValue.map(({ value }) => {
          return {
            label: value,
            value: value
          }
        })
        return _options
      }
    }

    return {
      ...toRefs(state),
      ...initList(),
      isEdit,
      couponID,
      tagVisible,
      getDetail,
      ...methods
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .label_h3 {
  font-weight: bold;
}
</style>
